var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCcmiGraphicLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.6 101",
    style: {
      enableBackground: "new 0 0 99.6 101"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#634595;}\n\t.st1{fill:#F9E200;}\n\t.st2{fill:#CE132E;}\n\t.st3{fill:#F0801A;}\n\t.st4{fill:#FFED00;}\n\t.st5{fill:#95C11F;}\n\t.st6{fill:#DE7AAF;}\n\t.st7{fill:#0082C2;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "fullLogo_56_",
    className: "st0",
    d: "M94.9,50.7c-2.6,0-4.6,2.1-4.6,4.6c0,2.6,2.1,4.6,4.6,4.6c2.6,0,4.6-2.1,4.6-4.6 C99.6,52.8,97.5,50.7,94.9,50.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "fullLogo_55_",
    className: "st1",
    d: "M60,44.2c0-3.3,2.6-5.9,5.8-5.9c0-3.2,0-6.7,0-6.7h-0.3c-3.7,0-7,1.5-9.5,3.9v0v0l0,0 c-2.4-2.4-5.8-3.9-9.5-3.9h-0.4c0,0,0,4.7,0,6.7c3.2,0,5.8,2.7,5.8,5.9c0,1.9-0.9,3.7-2.4,4.7c1.3,0.9,2.2,2.4,2.4,4.1v10.8h0v0 h3.9v0h4V53c0.2-1.7,1.1-3.1,2.4-4C61,47.9,60,46.2,60,44.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "fullLogo_54_",
    className: "st2",
    d: "M50.5,78.1C35.3,78.1,23,65.7,23,50.5C23,35.3,35.3,23,50.5,23v-9.2 c-20.3,0-36.7,16.5-36.7,36.7c0,20.3,16.5,36.7,36.7,36.7V78.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "fullLogo_53_",
    className: "st3",
    d: "M46.3,31.6H46c-7.4,0-12.5,6-12.5,13.4v18.9h7V53.7c0-1.9,1-3.6,2.4-4.7 c-1.5-1.1-2.4-2.8-2.4-4.8c0-3.3,2.6-5.9,5.8-5.9l0,0v0h0C46.3,36.3,46.3,31.6,46.3,31.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "fullLogo_52_",
    className: "st4",
    d: "M46.3,31.6L46.3,31.6c0,0,0,4.7,0,6.7h0V31.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "fullLogo_51_",
    className: "st5",
    d: "M66.3,31.6h-0.4v6.7c3.2,0,5.8,2.7,5.8,5.9c0,1.9-0.9,3.7-2.4,4.7c1.5,1.1,2.5,2.8,2.5,4.8 v10.2h7V45C78.8,37.6,73.7,31.6,66.3,31.6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "fullLogo_50_",
    className: "st6",
    d: "M98.8,65.4H89C86.1,73,81,79.5,74.4,84.2l4.9,7.8C88.5,85.6,95.4,76.3,98.8,65.4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "fullLogo_49_",
    className: "st7",
    d: "M50.5,91.8c-22.8,0-41.3-18.5-41.3-41.3c0-22.8,18.5-41.3,41.3-41.3c10,0,19.3,3.6,26.4,9.6 l7.1-6C75.1,4.8,63.4,0,50.5,0C22.7,0,0,22.7,0,50.5S22.7,101,50.5,101c10.7,0,20.6-3.4,28.8-9.1l-4.9-7.8 C67.7,89,59.4,91.8,50.5,91.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcmiGraphicLogoColor);
export default __webpack_public_path__ + "static/media/ccmi-graphic-logo-color.49aa59f5759ee28aa937c592a065ea67.svg";
export { ForwardRef as ReactComponent };